const awsMobile = {
  Auth: {
    userPoolId: 'us-west-2_gI6WIyfKr',
    userPoolWebClientId: '32mfitnridq3u91mtg2iajbbfc',
  },
};

export default awsMobile;
